const HOME = '/'
const ABOUT = '/About'
const SERVICE = '/Service'
const CONTACT = '/Contact'
const SOLUTION = '/Solution'

export {
    HOME,
    ABOUT,
    SERVICE,
    CONTACT,
    SOLUTION,
}
